import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getFetchSystems = createSelector(
    getModel,
    (model) => model.fetchSystems,
);

export const getIsFetchingSystems = createSelector(
    getFetchSystems,
    (model) => model.isFetching,
);

export const getFetchSystemsData = createSelector(
    getFetchSystems,
    (model) => model.data,
);

export const getFetchPresets = createSelector(
    getModel,
    (model) => model.fetchPresets,
);

export const getIsFetchingPresets = createSelector(
    getFetchPresets,
    (model) => model.isFetching,
);

export const getFetchPresetsData = createSelector(
    getFetchPresets,
    (model) => model.data,
);

export const getFetchItem = createSelector(
    getModel,
    (model) => model.fetchItem,
);

export const getIsFetchingItem = createSelector(
    getFetchItem,
    (model) => model.isFetching,
);

export const getFetchItemData = createSelector(
    getFetchItem,
    (model) => model.data,
);

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getSaveItem = createSelector(getModel, (model) => model.saveItem);

export const getIsSavingItem = createSelector(
    getSaveItem,
    (model) => model.isSaving,
);

export const getSaveItemErrors = createSelector(
    getSaveItem,
    (model) => model.errors,
);
